// data-fee-handling-product = fee handling product id

/* Paving calculation: 
  Total Creat area. Total area = 16.90 So Area per slab = Total area / Slabe per CRATE so 16.90/30 = 0.5633333333
  
  Slabs Required = Input Area ÷ Slab Area (round up). 
  Input 21 then 
  21 / 0.5633333333 = 38.88 so it’s 39 slabs here. Instead of 21 we need to adjust it as 39 *0.54 so 21.06 instead of 21. 
  
  Crates = Slabs ÷ Slabs per Crate (integer). 
  39 slab/30 = 1.3 
  1 create and 0.3 remain 
  
  Loose Slabs = Slabs per create * remain from Crates calculation 
  30*0.3 = 9  Loose Slabs 
   
  
  Adjusted Area = Total Slabs × Slab Area. 
*/

/* Linear meter calculation: 
  Pieces Required = Input Length ÷ Length per Piece (round up). 
  
  Packs = Pieces ÷ Pieces per Pack (integer). 
  
  Loose Pieces = Pieces ÷ Pieces per Pack (remainder). 
  
  Adjusted Length = Total Pieces × Length per Piece. 
*/

let debounceTimer;      
var Shopify = Shopify || {};
Shopify.bulkProductData = {};
Shopify.bulkProductData.bulk_products = [];
Shopify.bulkProductData.multivariants_selected_error_html = "{{ qty }}{{ name }} available.\u003cspan class='text--black'\u003e\u003ca href='\/pages\/contact-us' target='_blank'\u003eContact\u003c\/a\u003e if you need more.\u003c\/span\u003e";
Shopify.bulkProductData.multiAddtoCartHTML = `<span class="label-icon"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8.12671" cy="7.98218" r="7.51538" fill="white"></circle><path d="M8.65838 11.0947L8.65838 7.0661L10.4046 8.81768C10.5046 8.91763 10.6402 8.97378 10.7815 8.97378C10.9228 8.97378 11.0584 8.91763 11.1584 8.81768C11.2583 8.71773 11.3145 8.58218 11.3145 8.44083C11.3145 8.29948 11.2583 8.16392 11.1584 8.06397L8.50445 5.41007C8.45397 5.36175 8.39445 5.32387 8.32929 5.2986C8.20007 5.24552 8.05512 5.24552 7.9259 5.2986C7.86075 5.32387 7.80122 5.36175 7.75074 5.41007L5.09684 8.06397C5.04709 8.11332 5.0076 8.17202 4.98065 8.2367C4.95371 8.30138 4.93983 8.37076 4.93983 8.44083C4.93983 8.5109 4.95371 8.58027 4.98065 8.64495C5.0076 8.70963 5.04709 8.76834 5.09684 8.81768C5.14618 8.86743 5.20489 8.90692 5.26957 8.93387C5.33425 8.96081 5.40362 8.97469 5.47369 8.97469C5.54376 8.97469 5.61314 8.96081 5.67782 8.93387C5.7425 8.90692 5.8012 8.86743 5.85055 8.81768L7.59682 7.0661L7.59682 11.0947C7.59682 11.2355 7.65274 11.3705 7.75228 11.4701C7.85182 11.5696 7.98682 11.6255 8.1276 11.6255C8.26837 11.6255 8.40337 11.5696 8.50291 11.4701C8.60246 11.3705 8.65838 11.2355 8.65838 11.0947Z" fill="#636363"></path></svg></span>Add Qty to Place Order`

$(document).ready(function(){
  const fee_handling_product = $('body').data('fee-handling-product'), 
        fee_handling_product_price = $('body').data('fee-handling-product-price'),
        error_text = "Not enough quantity. Please contact our team for orders exceeding [items].",
        conversion_message = "Your [count] [items] have been converted to [pack_counts] [packs] and added to the [pack] quantity.",
        $priceParentWrp = $('calculator-product-form').find('[data-total-wrapper]'),
        $totalItemSelected = $('[data-total-qty-wrp]'),
        $add_to_cart = $('calculator-product-form').find('[name="add"]'),
        $add_to_cart_text = $add_to_cart.data('btn-text'),
        $main_product_title = $add_to_cart.data('main_product');
  
  // Tabbing
  $("body").on("click", ".cal-price-tab-header li", function (e) {
    e.preventDefault();
    var activeTab = $(this).attr("rel");
    if (!$(this).hasClass("active")) {
        $(".cal-price-tab-info").hide();
        $(`#${activeTab}`).fadeIn();
        $(".cal-price-tab-header li").removeClass("active");
        $(this).addClass("active");
    }
  });

  $('body').on('click', '[data-close-message]', function(e){
    e.preventDefault();
    var messageBoxParent = $('.cal-price-tab-info .message--tooltip');
    messageBoxParent.css({opacity: 0, visibility: 'hidden'});
  });

  $('calculator-product-form form').on('keydown', function(e) {
      if (e.key === 'Enter') {
          e.preventDefault(); // Prevent form submission on Enter key
      }
  });
  
  function formatNumber(num) {
    if (num == Math.floor(num)) {
      return Number(num);
    } else {
      return Number(
        Number(num)
          .toFixed(2)
          .replace(/\.00$/, "")
      );
    }
  };
  
  function addItemsToCart(box, innerItems, boxTarget, itemTarget, boxName, slabName) {
    const randomNumber = Math.floor(Math.random() * (900000 - 100000 + 1)) + 100000, 
          jsonData = [],
          localHandlingFeeCheck = localStorage.getItem("bulkHandlingFee") ? JSON.parse(localStorage.getItem("bulkHandlingFee")) : [];
  
    if (box > 0) {
      jsonData.push({
        quantity: box,
        id: boxTarget.data('option-id'),
      });
    }
  
    if (innerItems > 0) {
        // Add fee handling item (if applicable)
        if (fee_handling_product) {
            if ($.inArray(itemTarget.data('option-id'), localHandlingFeeCheck) === -1) {
                jsonData.push(
                    {
                        quantity: 1,
                        id: fee_handling_product,
                        properties: {
                            "_bundle_id": itemTarget.data('option-id'),
                            "_fee_handling": "YES",
                            "Charged for Product": $main_product_title
                        }
                    },
                    {
                        quantity: innerItems,
                        id: itemTarget.data('option-id'),
                        properties: { "_bundle_id": itemTarget.data('option-id'), "_fee_handling_added": "YES" }
                    }
                );
            } else {
                jsonData.push({
                    quantity: innerItems,
                    id: itemTarget.data('option-id'),
                    properties: { "_bundle_id": itemTarget.data('option-id'), "_fee_handling_added": "YES" }
                });
            }
        } else {
            jsonData.push({
                quantity: innerItems,
                id: itemTarget.data('option-id')
            });
        }
    }

    console.log(jsonData, 'jsonData');
    Shopify.bulkProductData.bulk_products = jsonData;
  }

  function showError($successMessage, $errorMessage) {
    $successMessage.hide();
    $errorMessage.show();
  }

  function hideError($successMessage, $errorMessage) {
    $errorMessage.hide();
    $successMessage.show();
  }
  
  function finalPriceCalculate(box, innerItems, boxTarget, itemTarget){
    var final_price = 0, price_wrapper = $('.custom--calculated-price [data-total-price]');

    const boxPrice = formatNumber(boxTarget.data('option-price')), 
          itemsPrice = formatNumber(itemTarget.data('option-price'));
  
    const feeHandlingPrice = fee_handling_product_price && innerItems > 0 ? formatNumber(fee_handling_product_price) : 0, 
          finalPrice = (box * boxPrice) + (innerItems * itemsPrice) + feeHandlingPrice;
  
    // Update price elements if they exist
    price_wrapper?.html(Shopify.formatMoney(finalPrice, window.custom_theme.money_format));
  
    console.log('Final Price:', Shopify.formatMoney(finalPrice, window.custom_theme.money_format)); 
    console.log('=========================================================');
  }
  
  function checkAvailability(ipEle, inputValue, nameType) {
    const invQty = parseFloat(ipEle.attr('max')),
          currentVal = parseFloat(ipEle.val()),
          plus_btn = ipEle.parent().find('.cal-qty-btn-plus'),
          minus_btn = ipEle.parent().find('.cal-qty-btn-min'),
          $errorMessage = ipEle.closest('.cal-price-qty-row').find('[data-error-msg]'),
          $successMessage = ipEle.closest('.cal-price-qty-row').find('[data-success-msg]');

    minus_btn.prop('disabled', false);
    hideError($successMessage, $errorMessage);
    if (typeof invQty !== 'undefined' && inputValue >= invQty) {
      plus_btn.prop('disabled', true);
      showError($successMessage, $errorMessage);
      if (inputValue > invQty) {
        return false;
      }
      return true;
    }
    if (currentVal <= 0) minus_btn.prop('disabled', true);
    plus_btn.prop('disabled', false);
    hideError($successMessage, $errorMessage);
    return true;
  }

  function convertSlabs($parent, area_input, area_input_name, crate_input, crate_inv, crate_input_name, slab_input, slab_inv, slab_input_name, number_of_boxes, number_of_items, piece_per_box, final_total_area, convert_slabs = false) {
    let cratePriceWrapper = crate_input.parents('.cal-price-qty-row').find('[data-item-per-price]'),
        currentCrateVal = parseFloat(crate_input.val()),
        cratePrice = crate_input.data('option-price'), 
        slabPriceWrapper = slab_input.parents('.cal-price-qty-row').find('[data-item-per-price]'), 
        slabPrice = slab_input.data('option-price'),
        messageBox = $('.cal-price-tab-info .conversion--message'), 
        messageBoxParent = messageBox.parent('.message--tooltip'),
        remainingItem = 0,
        final_text = $('[data-number-crates]'), 
        final_area = $('[data-area-size]'),
        text;

    console.log('Without Conversion: Crates: ', number_of_boxes, 'Slabs/QTY: ', number_of_items);
    messageBoxParent.css({opacity: 0, visibility: 'hidden'}); // new change 02-04-25
    
    if (number_of_items >= piece_per_box && convert_slabs) {
      var slab_remainder = (number_of_items/piece_per_box) % 1, crate_part = Math.floor(number_of_items/piece_per_box);
      number_of_boxes += crate_part;
      number_of_items = formatNumber(piece_per_box * slab_remainder);

      remainingItem = formatNumber(slab_input.val()) - number_of_items;

      console.log('Conversion: Crates: ', number_of_boxes, 'Slabs/QTY: ', number_of_items);
      
      if (!checkAvailability(crate_input, number_of_boxes, crate_input_name)) {
        var new_slabs_generated = (number_of_boxes - crate_inv) * piece_per_box;
        number_of_boxes = crate_inv;
        number_of_items = number_of_items + new_slabs_generated; 
        if (!checkAvailability(slab_input, number_of_items, slab_input_name)) {
          return false;
        }
      }      

      if (currentCrateVal >= 0 && currentCrateVal < crate_inv && remainingItem > 0) {
        messageBox.html(conversion_message
                        .replaceAll('[count]', remainingItem)
                        .replaceAll('[items]', slab_input_name + (slab_input_name.charAt(slab_input_name.length - 1) === 's' ? '' : 's' ))
                        .replaceAll('[packs]', crate_part == 1 ? crate_input_name : crate_input_name + (crate_input_name.charAt(crate_input_name.length - 1) === 's' ? ' ' : 's' ))
                        .replaceAll('[pack]', crate_input_name)
                        .replaceAll('[pack_counts]', crate_part));
        messageBoxParent.css({opacity: 1, visibility: 'visible'});
      } else if (currentCrateVal == crate_inv) {
        messageBoxParent.css({opacity: 0, visibility: 'hidden'});
      }
    } else {
      if (!checkAvailability(crate_input, number_of_boxes, crate_input_name)) {
        var new_slabs_generated = (number_of_boxes - crate_inv) * piece_per_box;
        number_of_boxes = crate_inv;
        number_of_items = number_of_items + new_slabs_generated;
        if (!checkAvailability(slab_input, number_of_items, slab_input_name)) {
          number_of_items = slab_inv; // new change 02-04-25
          // return false; // new change 02-04-25
        }
      }  
    }
    
    slabPriceWrapper.html(Shopify.formatMoney((number_of_items * slabPrice), window.custom_theme.money_format));
    cratePriceWrapper.html(Shopify.formatMoney((number_of_boxes * cratePrice), window.custom_theme.money_format));
    
    text = number_of_boxes > 1 
           ? (number_of_boxes + ' ' + crate_input_name + (crate_input_name.charAt(crate_input_name.length - 1) === 's' ? ' ' : 's ' ) + (number_of_items > 1 
                                                 ? (' & ' + number_of_items + ' ' + slab_input_name + (slab_input_name.charAt(slab_input_name.length - 1) === 's' ? ' ' : 's ' )) 
                                                 : (number_of_items > 0 
                                                    ? (' & ' + number_of_items + ' ' + slab_input_name) 
                                                    : ''
                                                   )
                                             )
             ) 
           : (number_of_boxes + ' ' + crate_input_name + (number_of_items > 1 
                                                ? (' & ' + number_of_items + ' ' + slab_input_name + (slab_input_name.charAt(slab_input_name.length - 1) === 's' ? ' ' : 's ' )) 
                                                : (number_of_items > 0 
                                                    ? (' & ' + number_of_items + ' ' + slab_input_name) 
                                                    : ''
                                                   )
                                             )
             );
    
    
      console.log('Total: Crates: ', number_of_boxes, 'Slabs/QTY: ', number_of_items);
      crate_input.val(number_of_boxes);
      slab_input.val(number_of_items);
    
      console.log('Final Total Area: ', final_total_area);
      area_input.val(formatNumber(final_total_area));
    
      final_area.html(formatNumber(final_total_area));
      final_text.html(text).parents('[data-total-qty-wrp]').show();
      final_text.attr('data-total-units', (number_of_boxes + (number_of_items >= 1 ? 1 : 0)));
  
      finalPriceCalculate(number_of_boxes, number_of_items, crate_input, slab_input);
      addItemsToCart(number_of_boxes, number_of_items, crate_input, slab_input, crate_input_name, slab_input_name);
    
      if (number_of_boxes > 0 || number_of_items > 0){
        $add_to_cart.removeAttr('disabled').html($add_to_cart_text);
        $priceParentWrp.show();
        $totalItemSelected.show();
      } else {
        $add_to_cart.attr('disabled', 'disabled').html(Shopify.bulkProductData.multiAddtoCartHTML);
        $priceParentWrp.hide();
        $totalItemSelected.hide();
      }
      checkAvailability(crate_input, number_of_boxes, crate_input_name);
      checkAvailability(slab_input, number_of_items, slab_input_name);
      checkAvailability(area_input, final_total_area, area_input_name);
  }
  
  function calculateArea(_this, area_per, total_area, piece_per_box, block_type, name_type){  
    const $parent = _this.parents('.cal-price-tab-body');
    area_per = area_per, total_area = formatNumber(total_area), piece_per_box = formatNumber(piece_per_box);
  
    if (block_type == 'paving') {
      console.log('**** PAVING CALULATOR ****');
      var area_input = $parent.find('input[name="area"]'), 
          crate_input = $parent.find('input[name="crate"]'), 
          slab_input = $parent.find('input[name="Step"]').length > 0 ? $parent.find('input[name="Step"]') : $parent.find('input[name="Sett"]').length > 0 ? $parent.find('input[name="Sett"]') : $parent.find('input[name="Paver"]').length > 0 ? $parent.find('input[name="Paver"]') : $parent.find('input[name="Slab"]');
    } else if (block_type == 'linear-meter') {
       console.log('**** LINEAR METER CALULATOR ****');
       var area_input = $parent.find('input[name="length"]'), 
           crate_input = $parent.find('input[name="crate"]'), 
           slab_input = $parent.find('input[name="Step"]').length > 0 ? $parent.find('input[name="Step"]') : $parent.find('input[name="Sett"]').length > 0 ? $parent.find('input[name="Sett"]') : $parent.find('input[name="Paver"]').length > 0 ? $parent.find('input[name="Paver"]') : $parent.find('input[name="Piece"]');
    }

    var crate_input_name = crate_input.data('option-name'),
        number_of_boxes = formatNumber(crate_input.val()), 
        crate_inv = formatNumber(crate_input.attr('max')),
      
        slab_input_name = slab_input.data('option-name'),
        number_of_items = formatNumber(slab_input.val()), 
        smallest_unit_ava = formatNumber(slab_input.data('smallest-unit')),
        slab_inv = formatNumber(slab_input.attr('max')),
      
        area_input_val = formatNumber(area_input.val()),
        area_input_name = area_input.data('option-name'),
        area_inv = formatNumber(area_input.attr('max')),
        final_total_area = 0;
  
    console.log('Area per ' + slab_input_name +': ', area_per, ' Total '+ crate_input_name +' area: ', total_area, ' '+ slab_input_name +' per '+ crate_input_name +': ', piece_per_box);

    if (_this.attr('name') == 'crate' || _this.attr('name') == 'pack') {
        crate_input.val(number_of_boxes);
        final_total_area = (number_of_boxes * total_area) + (number_of_items * (area_per/smallest_unit_ava));
        convertSlabs($parent, area_input, area_input_name, crate_input, crate_inv, crate_input_name, slab_input, slab_inv, slab_input_name, number_of_boxes, number_of_items, piece_per_box, final_total_area);
    }

    if (_this.attr('name') == 'Slab' || _this.attr('name') == 'Piece' || _this.attr('name') == 'Step' || _this.attr('name') == 'Sett' || _this.attr('name') == 'Paver') {
      final_total_area += (number_of_boxes * total_area) + (number_of_items * (area_per/smallest_unit_ava));
      convertSlabs($parent, area_input, area_input_name, crate_input, crate_inv, crate_input_name, slab_input, slab_inv, slab_input_name, number_of_boxes, number_of_items, piece_per_box, final_total_area, true);
    }
  
    if (_this.attr('name') == 'area' || _this.attr('name') == 'length') {
      var adjust_slabs_by = Math.ceil(area_input_val / area_per);
      final_total_area = formatNumber((formatNumber(adjust_slabs_by)) * area_per);
      
      var slab_remainder = (adjust_slabs_by/piece_per_box) % 1, crate_part = Math.floor(adjust_slabs_by/piece_per_box);
      
      number_of_boxes = crate_part;
      number_of_items = formatNumber(piece_per_box * slab_remainder) * smallest_unit_ava;

      checkAvailability(area_input, final_total_area, area_input_name);
      convertSlabs($parent, area_input, area_input_name, crate_input, crate_inv, crate_input_name, slab_input, slab_inv, slab_input_name, number_of_boxes, number_of_items, piece_per_box, final_total_area, true);
    }
  }
  
  // QUANTITY CHANGE START 
  $('body').on('click', '.cal-qty-btn', function (e) {
      e.preventDefault();
      
      var $button = $(this),
          $parentWrapper = $button.parents('[data-calculator-box]'),
          areaPer = $parentWrapper.data('area-per'),
          totalArea = $parentWrapper.data('total-area'),
          piecePerBox = $parentWrapper.data('piece_per_box'),
          $inputWrapper = $button.closest('.cal-price-qty').find('input'),
          inputValue = parseFloat($inputWrapper.val()),
          maxLimit = parseFloat($inputWrapper.attr('max')),
          smallestUnit = formatNumber($inputWrapper.data('smallest-unit')),
          blockType = $inputWrapper.data('type'),
          nameType = $inputWrapper.data('option-name'),
          $successMessage = $button.closest('.cal-price-qty-row').find('[data-success-msg]'),
          $errorMessage = $button.closest('.cal-price-qty-row').find('[data-error-msg]'),
          $minusButton = $button.closest('.cal-price-qty').find('.cal-qty-btn-min'),
          $plusButton = $button.closest('.cal-price-qty').find('.cal-qty-btn-plus');

      hideError($successMessage, $errorMessage);
  
      if ($button.hasClass('cal-qty-btn-plus')) {
          inputValue = formatNumber(inputValue) + smallestUnit;
          if (inputValue > maxLimit) {
            inputValue = formatNumber(inputValue) - smallestUnit + 1;
          }
          $minusButton.prop('disabled', false);
      } else {
          inputValue = formatNumber(inputValue) - smallestUnit;
          $plusButton.prop('disabled', false);
      }
  
      inputValue = Math.max(inputValue, 0);
      $inputWrapper.val(formatNumber(inputValue));
  
      if (typeof maxLimit !== 'undefined' && inputValue >= maxLimit && inputValue > 0) {
          $plusButton.prop('disabled', true);
          showError($successMessage, $errorMessage);
      } else if (inputValue === 0) {
          $minusButton.prop('disabled', true); // Disable minus button if value is 0
      }
  
      calculateArea($inputWrapper, areaPer, totalArea, piecePerBox, blockType, nameType);
  });

  // Input change on AREA
  $('body').on('keyup', '.cal-price-tab-info input[type="number"]', function (e) {
    var _this = $(this),
        $parent = _this.parents('.cal-price-qty-row'),
        parent_wrapper = $(this).parents('[data-calculator-box]'),
        area_per = parent_wrapper.data('area-per'),
        total_area = parent_wrapper.data('total-area'),
        piece_per_box = parent_wrapper.data('piece_per_box'),
        $errorMessage = $parent.find('[data-error-msg]'),
        $successMessage = $parent.find('[data-success-msg]'),
        block_type = _this.data('type'),
        nameType = _this.data('option-name'),
        max_limit = formatNumber(_this.attr('max')),
        currentVal = _this.val();

    hideError($successMessage, $errorMessage);
    clearTimeout(debounceTimer);
    if (currentVal < 0) return false;

    if (currentVal >= 0) {
        debounceTimer = setTimeout(function () {
          if (currentVal == 0){
            $parent.find('.cal-qty-btn-plus').prop('disabled', false);
            $parent.find('.cal-qty-btn-min').prop('disabled', true);
          }
          if (currentVal > 0 && currentVal < max_limit){
            $parent.find('.cal-qty-btn-plus').prop('disabled', false);
            $parent.find('.cal-qty-btn-min').prop('disabled', false);
          }
          if (currentVal > max_limit) { // Check if input_value exceeds max_limit
            currentVal = max_limit;
            _this.val(currentVal);
            $parent.find('.cal-qty-btn-plus').prop('disabled', true);
            $parent.find('.cal-qty-btn-min').prop('disabled', false);
            showError($successMessage, $errorMessage);
          }
          calculateArea(_this, area_per, total_area, piece_per_box, block_type, nameType);
        }, 500);
    }
  });
});
